import { useCallback, useState } from "react";
import { AdSlot } from "@/components/ads/AdSlot";
import type { AdUnitKey } from "@/lib/adUnits";

interface AdFillProps {
  /** Google AdSense unit. */
  unit: AdUnitKey;
  className?: string;
}

/**
 * One AdSense advertising space. If AdSense reports no ad for this visitor
 * the space collapses, so a page never carries a labelled blank box.
 * AdSense is the only ad network on Statlign.
 */
export function AdFill({ unit, className }: AdFillProps) {
  const [empty, setEmpty] = useState(false);
  const onStatus = useCallback((filled: boolean) => {
    if (!filled) setEmpty(true);
  }, []);
  if (empty) return null;
  return <AdSlot unit={unit} onStatus={onStatus} {...(className ? { className } : {})} />;
}
